import { render } from "./SendFile.vue?vue&type=template&id=5262ec34"
import script from "./SendFile.vue?vue&type=script&lang=js"
export * from "./SendFile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__